import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    analyticsService.trackPageView(location.pathname);
  }, [location]);

  const trackEvent = (eventName, properties = {}) => {
    analyticsService.trackEvent(eventName, properties);
  };

  const trackConversion = (conversionType, value = null) => {
    analyticsService.trackConversion(conversionType, value);
  };

  const trackUserAction = (action, details = {}) => {
    analyticsService.trackUserAction(action, details);
  };

  // Mixpanel-specific methods
  const identifyUser = (userId, userProperties = {}) => {
    analyticsService.identifyUser(userId, userProperties);
  };

  const setUserProperties = (properties) => {
    analyticsService.setUserProperties(properties);
  };

  const trackRevenue = (amount, properties = {}) => {
    analyticsService.trackRevenue(amount, properties);
  };

  // Product usage tracking methods
  const trackFeatureUsage = (feature, properties = {}) => {
    analyticsService.trackFeatureUsage(feature, properties);
  };

  const trackModuleAccess = (module, properties = {}) => {
    analyticsService.trackModuleAccess(module, properties);
  };

  const trackChatInteraction = (action, properties = {}) => {
    analyticsService.trackChatInteraction(action, properties);
  };

  const trackDocumentUpload = (documentType, properties = {}) => {
    analyticsService.trackDocumentUpload(documentType, properties);
  };

  const trackSearchQuery = (query, resultsCount = 0) => {
    analyticsService.trackSearchQuery(query, resultsCount);
  };

  const trackPlanUpgrade = (fromPlan, toPlan, properties = {}) => {
    analyticsService.trackPlanUpgrade(fromPlan, toPlan, properties);
  };

  const trackTeamInvitation = (invitationType, properties = {}) => {
    analyticsService.trackTeamInvitation(invitationType, properties);
  };

  const resetUser = () => {
    analyticsService.resetUser();
  };

  // Page analytics methods
  const getPageAnalytics = () => {
    return analyticsService.getPageAnalytics();
  };

  const trackPageTimeSpent = (pagePath, timeSpent) => {
    analyticsService.trackPageTimeSpent(pagePath, timeSpent);
  };

  const trackPageExit = () => {
    analyticsService.trackPageExit();
  };

  const trackPageReturn = () => {
    analyticsService.trackPageReturn();
  };

  return {
    // Basic tracking methods
    trackEvent,
    trackConversion,
    trackUserAction,
    
    // Mixpanel-specific methods
    identifyUser,
    setUserProperties,
    trackRevenue,
    resetUser,
    
    // Product usage tracking methods
    trackFeatureUsage,
    trackModuleAccess,
    trackChatInteraction,
    trackDocumentUpload,
    trackSearchQuery,
    trackPlanUpgrade,
    trackTeamInvitation,
    
    // Page analytics methods
    getPageAnalytics,
    trackPageTimeSpent,
    trackPageExit,
    trackPageReturn
  };
}; 